import React from 'react';

import { StatusTestUser } from 'components/common/Elements/Elements';
// import classes from './Storybook.module.scss';
// import { exportPNG } from 'utils/exportPNG';

// import {} from 'data/ngroks';

const Storybook = () => {
  return (
    <div>
      <StatusTestUser />
    </div>
  );
};
export default Storybook;
